import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { DigitalAsset } from '@promoboxx/graphql-gateway-types'
import I18n from 'i18n-js'

import BaseAssetCard from './BaseAssetCard'
import DigitalAssetIcon from './DigitalAssetIcon'
import { useCurrentIds } from './useCurrentIds'

type DigitalAssetCardProps = {
  digitalAsset: DigitalAsset
  isSelected?: boolean
  assetsSelected?: boolean
  onShowPreview?: (digitalAsset: DigitalAsset) => void
  onSelect?: (
    event: React.MouseEvent,
    isSelected: boolean,
    digitalAsset: DigitalAsset,
  ) => void
  onClickDelete?: (event: React.MouseEvent, digitalAsset: DigitalAsset) => void
}
const DigitalAssetCard: React.FC<
  React.PropsWithChildren<DigitalAssetCardProps>
> = (props) => {
  const { brands } = useCurrentIds()

  const handleShowPreview = () => {
    if (props.onShowPreview) {
      props.onShowPreview(props.digitalAsset)
    }
  }

  const handleSelect = (event: React.MouseEvent, isSelected: boolean) => {
    if (props.onSelect) {
      props.onSelect(event, isSelected, props.digitalAsset)
    }
  }

  const handleDownloadClick = () => {
    if (props.digitalAsset.download_url) {
      const link = document.createElement('a')
      link.target = '_blank'
      link.download =
        props.digitalAsset.name || props.digitalAsset.file?.public_id || ''
      link.href = props.digitalAsset.download_url
      link.click()
    }
  }

  return (
    <BaseAssetCard
      assetsSelected={props.assetsSelected || false}
      digitalAsset={props.digitalAsset}
      isSelected={props.isSelected}
      onClickDownload={handleDownloadClick}
      onSelect={props.onSelect && handleSelect}
      onShowPreview={props.onShowPreview && handleShowPreview}
      primaryText={
        <>
          <Box alignItems="center" display="flex">
            <DigitalAssetIcon
              className="fa-2x"
              fileName={props.digitalAsset?.name || ''}
              style={{
                color: '#ccc',
                marginRight: '8px',
              }}
            />
            <span data-testid={`digitalAsset: ${props.digitalAsset.name}`}>
              {props.digitalAsset.name}
            </span>
          </Box>
          <Box
            alignItems="center"
            display="flex"
            justifyContent="space-between"
            pt={2}
          >
            {props.digitalAsset.file && (
              <Typography color="textSecondary" variant="caption">
                {I18n.toHumanSize(props.digitalAsset?.file?.bytes || 0)}
              </Typography>
            )}
            {props.digitalAsset.file?.width &&
              props.digitalAsset.file?.height && (
                <Typography color="textSecondary" variant="caption">
                  {`${props.digitalAsset.file.width} x
                  ${props.digitalAsset.file.height}`}
                </Typography>
              )}
            <Typography color="textSecondary" variant="caption">
              {brands[props.digitalAsset.associable_id]?.name}
            </Typography>
          </Box>
        </>
      }
    />
  )
}

export default DigitalAssetCard
